import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

import { createWhitelabelTheme } from "./whitelabelThemeCreator";
import { BRUKY_COLORS } from "./bruky";

const themeLoader = () => {
  const currentUrl = window.location.hostname.toLocaleLowerCase();
  let brandColors;

  switch (currentUrl) {
    case `${process.env.REACT_APP_URL_BRUKY}`:
      brandColors = BRUKY_COLORS;
      break;
    default:
      brandColors = {};
  }

  return createWhitelabelTheme(brandColors);
};

export const ThemeProvider = ({ children }) => {
  const brandTheme = themeLoader();
  return <MuiThemeProvider theme={brandTheme}>{children}</MuiThemeProvider>;
};
